import './sequencepopup.less'

import {SequenceModel} from 'models/program/SequenceModel'
import React from 'react'
import {useIsDark} from 'util/hooks'
import {style} from 'util/style'
import {PopupModal} from 'views/layout/popupmodal'
import {ProgramPopupHeader, ProgramPopupLinks} from 'views/program/programpopup'

const styles = style('sequencepopup')

export const SequencePopup: React.FC<{
	sequence: SequenceModel
}> = ({sequence}) => {
	const {title, start_time, end_time, room} = sequence
	const isDark = useIsDark()

	return (
		<div className={styles().mod({dark: isDark})}>
			<PopupModal.Content>
				<ProgramPopupHeader
					title={title}
					start_time={start_time}
					end_time={end_time}
					location={room}
				/>
			</PopupModal.Content>
			<ProgramPopupLinks sessions={sequence.sessions} />
		</div>
	)
}
